export class AssetRole {
  static upload = 'asset.upload';
  static update = 'asset.update';
  static delete = 'asset.delete';
  // user should only see lowres formats
  static lowres = 'asset.downloadonlylowres';
  // user can download expired assets as well
  static downloadExpired = 'asset.expired.download';
  // user can see and edit an admin comment
  static adminComment = 'asset.commentfield';
  static accessDraft = 'asset.draft';
  // status permissions
  static statusAll = 'asset.update.allstatus';
  static statusPublishedOnly = 'asset.publishedassets';
  static statusUploadedAwaitingApproval = 'asset.uploadednawaitingapproval';
  static statusArchived = 'asset.archived';
  static statusDraft = 'asset.draft';

  static all = [this.upload, this.update, this.delete];
}

export class ReportRole {
  static metadata = 'report.export.metadata';
  static download = 'report.export.downloads';
  static userReport = 'report.login.users';

  static all = [this.metadata, this.download, this.userReport];
}

export class CollectionRole {
  static publish = 'asset.collection.publish';
}

export class TaskRole {
  static create = 'task.create';
  static update = 'task.update';
  static delete = 'task.delete';
  static follow = 'task.follow';
  static performannotate = 'task.performannotate';

  static all = [this.create, this.update, this.delete];
}

export class ProjectRole {
  static create = 'project.create';
  static update = 'project.update';
  static delete = 'project.delete';
  static follow = 'project.follow';

  static all = [this.create, this.update, this.delete];
}

export class ForecastRole {
  static create = 'forecast.create';
  static update = 'forecast.update';
  static delete = 'forecast.delete';

  static all = [this.create, this.update, this.delete];
}

export class AdminTagGroupRole {
  static admintags = 'global.admin.tags';
}

export class SpecialRole {
  static exchange = 'special.exchange'; // Used by Vorwerk in main navigation
}

export function NotRole(role: string) {
  return `!${role}`;
}
